import { Box, Button } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import InputForm from "../forms/inputForm";
import { useAppDispatch } from "../../../store";
import { useEffect, useState } from "react";
import useDebouncedEffect from "../../../hooks/useDebouncedEffect";
import DatePickerForm from "../forms/datePickerForm";
import dayjs from "dayjs";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import SelectForm from "../forms/selectFormm";

const schema = yup.object({
  title: yup.string().required(),
});

const UserAdminSearch = ({ params, setParams }: any) => {
  const [searchFilterDebounced, setSearchFilterDebounced] = useState("");
  const [email, setEmail] = useState("");
  const [lastLogin, setLastLogin] = useState("");
  const [userActive, setUserActive] = useState("");
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const {
    control,
    formState: { errors },
  } = useForm<{
    email: string;
    lastLogin: string;
    status: string;
  }>({
    reValidateMode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: {
      email: "",
      lastLogin: "",
      status: ""
    },
  });

  const optSelect = [
    {
      label: "ACTIVE",
      value: "ACTIVE",
    },
    {
      label: "INACTIVE",
      value: "INACTIVE",
    },
  ];

  const handleEmail = (e: string) => { setEmail(e); };
  const handleLastLogin = (e: any) => {
    let NewDate: any;
    if (e !== null) {
      NewDate = dayjs(e).format("YYYY-MM-DD");
    } else {
      NewDate = "";
    }
    setLastLogin(NewDate);
  };
  const handleStatusSelect = (e: any) => { 
    if(e === null ){
      setUserActive('')  
    } else {
      setUserActive(e.value);
    }
  };

  useDebouncedEffect(() => setSearchFilterDebounced(email), [email], 500);
  useDebouncedEffect(() => setSearchFilterDebounced(lastLogin), [lastLogin], 500); 
  useDebouncedEffect(() => setSearchFilterDebounced(userActive), [userActive], 500); 

  useEffect(() => {
    setParams({
      ...params,
      adm_user_email: email,
      adm_user_last_login_start: lastLogin,
      adm_user_status: userActive,
    });
  }, [searchFilterDebounced]);
  

  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "row", gap: "1rem", flex: 1 }}>
        <InputForm
          name="email"
          errors={errors}
          control={control}
          required
          placeholder="Email"
          maxLength={100}
          isLoading={false}
          onChange={handleEmail}
        />
        <DatePickerForm
          name="lastLogin"
          defaultValue={null}
          control={control}
          errors={errors}
          placeholder="Last Login"
          disabled={false}
          isLoading={false}
          required
          onChange={handleLastLogin}
        />
        <SelectForm 
          name="status"
          defaultValue={1}
          options={optSelect}
          placeholder="Status"
          disabled={false}
          isLoading={false}
          control={control}
          errors={errors}
          required
          isClear
          sxFL={{ backgroundColor: "red" }}
          onChangeForm={handleStatusSelect}
        />
        <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/user-admin/create")}
            sx={{ marginBottom: "0px", marginTop: "8px", height: '40px', width: '200px' }}
          >
            <AddIcon /> Create User Admin
          </Button>
      </Box>
    </Box>
  );
};

export default UserAdminSearch;
